import { render, staticRenderFns } from "./AddLoadTeacher.vue?vue&type=template&id=20b2dbc7"
import script from "./AddLoadTeacher.vue?vue&type=script&lang=js"
export * from "./AddLoadTeacher.vue?vue&type=script&lang=js"
import style0 from "./AddLoadTeacher.vue?vue&type=style&index=0&id=20b2dbc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports